import { render } from "./DataAssetDIMContainer.vue?vue&type=template&id=e765ec42"
import script from "./DataAssetDIMContainer.vue?vue&type=script&lang=js"
export * from "./DataAssetDIMContainer.vue?vue&type=script&lang=js"

import "./DataAssetDIMContainer.vue?vue&type=style&index=0&id=e765ec42&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/DataAssetDIMContainer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e765ec42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e765ec42', __exports__)) {
    api.reload('e765ec42', __exports__)
  }
  
  module.hot.accept("./DataAssetDIMContainer.vue?vue&type=template&id=e765ec42", () => {
    api.rerender('e765ec42', render)
  })

}


export default __exports__